import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	globalComponentsHeader: {
		id: 'project-directories.components.create-modal.global-components-header',
		defaultMessage: 'Create Jira component',
		description: '',
	},
	header: {
		id: 'project-directories.components.create-modal.header',
		defaultMessage: 'Create component',
		description: '',
	},
	saveButton: {
		id: 'project-directories.components.create-modal.save-button',
		defaultMessage: 'Save',
		description: '',
	},
	cancelButton: {
		id: 'project-directories.components.create-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: '',
	},
});
